<template>
  <PopupBox :title="$t('new_object', { object: $t('models.note') })">
    <template v-slot:control>
      <button class="btn btn-sm" @click="onCloseNotePopup">
        <show-icon name="close" size="sm"></show-icon>
      </button>
    </template>
    <div style="min-height: 50vh" class="row overflow-auto text-start">
      <NoteForm :site-id="siteId"
                :owner-type="ownerType"
                :owner-id="ownerId"
                v-bind="$attrs">
      </NoteForm>
    </div>
  </PopupBox>
</template>

<script>
//import { useStore } from 'vuex'
import PopupBox from '@/components/PopupBox.vue'
import NoteForm from '@/views/notes/Form.vue'

export default {
  name: "NewNotePopup",
  props: [
    "siteId",
    "ownerType",
    "ownerId"
  ],
  emits: [
    "closeNotePopup"
  ],
  setup(props) {
    console.log("Inside views/notes/NewNotePopup.vue, setup(): props ==> ", props);
  },
  methods: {
    onCloseNotePopup() {
      this.$emit("closeNotePopup");
    }
  },
  components: {
    PopupBox,
    NoteForm
  }  
}
</script>